export enum DateType {
    Start = 1,
    End = 2
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker-list/date-type.model.ts